import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { containsNetworkError } from '@confluence/network';

import type { BreadcrumbsType } from './useEditorBreadcrumbs.ts';
import type { EditorBreadcrumbsQuery as EditorBreadcrumbsQueryType } from './__types__/EditorBreadcrumbsQuery.ts';

export function handleEditorBreadcrumbsQueryResult(
	data: EditorBreadcrumbsQueryType | undefined,
	error: Error | undefined,
): BreadcrumbsType {
	if (error) {
		if (containsNetworkError(error) || isUnauthorizedError(error)) {
			markErrorAsHandled(error);
		} else {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.PAGE_MODES,
			});
		}
	}

	return (data?.experimentalEditorBreadcrumbs?.breadcrumbs || []) as BreadcrumbsType;
}
